import { SelectStatic } from "@common/controls/Inputs/Select/Base/component";

export default SelectStatic;

export {
  ContentBase,
  GroupSelectItem,
  IconSelectItem,
  SelectItem,
  SelectStaticContent,
  SelectStaticWithAdd,
  type FooterProps,
  type SelectHeading,
  type SelectStaticProps
} from "@common/controls/Inputs/Select/Base/component";
